/* eslint-disable react/prop-types */

import React from 'react'
import { connect } from 'react-redux'

import * as Content from '../reducers/Content'

import Spinner from './Spinner'

const ImageNode = (props) => {
  const { uploading, node } = props
  const url = Content.imageURL(node.image)
  return (
    <div className="imageNode">
      <div className="imageNodeContent">
        {uploading ? <Spinner /> : <img src={url} alt="" draggable="false" />}
        {node.title && node.title.length > 0 && (
          <div className="nodeImageTitle">{node.title}</div>
        )}
      </div>
    </div>
  )
}

function mapStateToProps(state, ownProps) {
  let uploading = false
  if (Content.isImageNode(ownProps.node)) {
    uploading = state.app.uploading[ownProps.node.image] ?? false
  }
  return {
    uploading,
  }
}

const ConnectedImageNode = connect(mapStateToProps)(ImageNode)

export default ConnectedImageNode
